module.exports = __webpack_public_path__ + "img/bar-gray.9cdf77a8.png";